//获取某一年是否为闰年
var isLeapYear = function (year) {
  return year % 100 == 0 ? (year % 400 == 0 ? 1 : 0) : (year % 4 == 0 ? 1 : 0);
}
var calendar = {
  //展示的日
  showDay: false,
  //展示的月
  showMonth: false,
  //展示的年
  showYear: false,
  //月历dom:
  calendar_dom: null,
  //月历容器
  calendar_container: null,
  //日期字符串分隔符：
  sepsign: "-",
  
  currViewInfo: {
    minDate: null,
    maxDate: null,
  },
  /**
   * 周历：
   * currWeekOffset：偏移量
   * weekOffsetWay：偏移方式（0 向前 1 向后）
   * weekCalendarOffset：偏移方法
   */
  //--------------
  currWeekOffset: 0,
  weekOffsetWay: 1,
  weekPreviewMonth: null,
  //周日历偏移基准值
  weekBaseYear: null,
  weekBaseMonth: null,
  weekBaseDate: null,
  //--------------
  //每个月天数数组
  days_per_month: [31, 28 + isLeapYear(this.showMonth), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  //星期数组
  week_arr: ["日", "一", "二", "三", "四", "五", "六"],
  //获取今天的年月日信息
  gettodayinfo: function () {
    var today = new Date();
    return [today.getFullYear(), today.getMonth(), today.getDate()];
  },
  //获取预览的年月日信息
  getPreviewinfo: function () {
    var today = new Date();
    return [this.showYear, this.showMonth];
  },
  //获取预览的周信息
  previewWeekInfo: "近两周",
  createParam: {},
  //创建日历
  create: function (data) {
    data ? this.createParam = data : "";
    this.calendar_container.innerHTML = "";
    
    var y = typeof (this.showYear) == "number" ? this.showYear : this.gettodayinfo()[0];
    this.showYear = y;
    
    var m = typeof (this.showMonth) == "number" ? this.showMonth : this.gettodayinfo()[1];
    this.showMonth = m;
    
    this.showDay = new Date().getDate();
    
    var firstdate = new Date(y, m, 1);
    var firstdayweek = firstdate.getDay();
    
    //计算日历所需行数
    var calendar_row = Math.ceil((firstdayweek + this.days_per_month[m]) / 7)
    
    
    //今天日期数组
    var todayDateArr = this.gettodayinfo();
    
    //遍历生成dom
    var calendar = document.createElement("div");
    this.calendar_dom = calendar;
    calendar.setAttribute("class", "calendar");
    var weekstr = "";
    for (var i = 0; i < this.week_arr.length; i++) {
      weekstr += "<div class='col'>" + this.week_arr[i] + "</div>";
    }
    calendar.innerHTML = "<div class='row'>" + weekstr + "</div>";
    for (var i = 0; i < calendar_row; i++) {
      var calendarRow = document.createElement("div");
      calendarRow.setAttribute("class", "row");
      for (var x = 0; x < 7; x++) {
        //设置日dom节点属性
        var idx = i * 7 + x;
        var currdate = idx - firstdayweek + 1;
        var domkey = idx - firstdayweek + 1;
        if (currdate <= 0 || currdate > this.days_per_month[m]) {
          currdate = false;
        }
        
        var calendarCol = document.createElement("div");
        calendarCol.setAttribute("class", "col");
        calendarCol.setAttribute("datestr", this.showYear + this.sepsign + (this.showMonth + 1) + this.sepsign + currdate);
        
        calendarCol.setAttribute("date", domkey);
        calendarCol.innerHTML = currdate ? (`<span class="dateInner">${currdate}</span>`) : " ";
        
        if (this.showYear == todayDateArr[0] && this.showMonth == todayDateArr[1] && domkey == todayDateArr[2]) {
          calendarCol.setAttribute("class", calendarCol.getAttribute("class") + " today");
          calendarCol.innerHTML = '今';
        }
        
        if (currdate) {
          calendarCol.className += " payload";
        }
        calendarCol.addEventListener("click", this.createParam.dateclick)
        calendarRow.appendChild(calendarCol);
      }
      calendar.appendChild(calendarRow);
    }
    this.currViewInfo.minDate = [this.showYear, (this.showMonth + 1), "1"];
    this.currViewInfo.maxDate = [this.showYear, (this.showMonth + 1), this.days_per_month[this.showMonth]];
    this.calendar_container.appendChild(calendar);
    this.createParam.finishCB();
    
  },
  //初始化
  createWeek: function (data) {
    //重置偏移量
    this.currWeekOffset = 0;
    data ? this.createParam = data : "";
    this.calendar_container.innerHTML = "";
    
    
    //初始化变量
    var y = typeof (this.showYear) == "number" ? this.showYear : this.gettodayinfo()[0];
    this.showYear = y;
    this.weekBaseYear = this.showYear;
    var m = typeof (this.showMonth) == "number" ? this.showMonth : this.gettodayinfo()[1];
    this.showMonth = m;
    this.weekBaseMonth = this.showMonth;
    this.weekBaseDate = this.gettodayinfo()[2];
    
    
    console.log(`%c日程周日历初始化完成，当前显示：${y}-${m + 1}`, 'color:#000;font-size:20px;border:5px solid #060;padding:10px')
    
    //生成日历表头
    var calendar = document.createElement("div");
    this.calendar_dom = calendar;
    calendar.setAttribute("class", "calendar-main");
    var weekstr = "";
    for (var i = 0; i < this.week_arr.length; i++) {
      weekstr += "<div class='col'>" + this.week_arr[i] + "</div>";
    }
    calendar.innerHTML = "<div class='row'>" + weekstr + "</div>";
    
    //生成日历主体容器
    var calendarRows = document.createElement("div");
    calendarRows.setAttribute("class", "rows");
    calendarRows.setAttribute("id", "calendarRows");
    this.calendar_container.appendChild(calendar);
    this.calendar_container.appendChild(calendarRows);
    
    
    //设置周日历生成模式
    var todayWeekIdx = new Date().getDay();
    if (todayWeekIdx > 2) {
      //周三及周三后，显示当前周和下周
      this.weekOffsetWay = 1;
    } else {
      //周三前显示，显示上周和当前周
      this.weekOffsetWay = 0;
    }
    
    //进入正常流程
    this.createWeekGeneral(2);
    this.createParam.finishCB()
  },
  //通常情况生成周历（正常流程）
  createWeekGeneral: function (way) {
    var calendarRows = this.calendar_container.querySelector("#calendarRows");
    calendarRows.innerHTML = "";
    
    //初始化特殊处理
    if (way !== 2) {
      if (way) {
        this.currWeekOffset++;
      } else {
        this.currWeekOffset--;
      }
    }
    
    var leftArr;    //最前的时间
    var rightArr;   //最后的时间
    
    //分模式生成两周数据
    if (this.weekOffsetWay) {
      leftArr = this.getWeekArrByIdx(this.currWeekOffset);
      calendarRows.appendChild(this.getDateDomByDateArr(leftArr));
      rightArr = this.getWeekArrByIdx(this.currWeekOffset + 1);
      calendarRows.appendChild(this.getDateDomByDateArr(rightArr));
      this.previewWeekInfo = leftArr[0].join(this.sepsign) + "~" + rightArr[rightArr.length - 1].join(this.sepsign);
    } else {
      leftArr = this.getWeekArrByIdx(this.currWeekOffset - 1);
      calendarRows.appendChild(this.getDateDomByDateArr(leftArr));
      rightArr = this.getWeekArrByIdx(this.currWeekOffset);
      calendarRows.appendChild(this.getDateDomByDateArr(rightArr));
      this.previewWeekInfo = leftArr[0].join(this.sepsign) + "~" + rightArr[rightArr.length - 1].join(this.sepsign);
    }
    //展示的日期区间
    this.weekPreviewMonth = [leftArr[0], rightArr[rightArr.length - 1]];
    //最小日期
    this.currViewInfo.minDate = leftArr[0];
    
    
    //周一日期
    this.currViewInfo.monday = leftArr[1];
    //最大日期
    this.currViewInfo.maxDate = rightArr[rightArr.length - 1];
    this.setShowDateInWeekMode(leftArr, rightArr, this.weekOffsetWay)
  },
  setShowDateInWeekMode(leftArr, rightArr, way) {
    let todayIdx = new Date().getDay()
    if (way) {
      this.showYear = leftArr[todayIdx][0]
      this.showMonth = leftArr[todayIdx][1] - 1
    } else {
      this.showYear = rightArr[todayIdx][0]
      this.showMonth = rightArr[todayIdx][1] - 1
    }
  },
  //日期对象转日期数组
  getDateArrByDateObj: function (dateObj) {
    let year = dateObj.getFullYear();
    let month = dateObj.getMonth();
    let date = dateObj.getDate();
    return [year, month, date]
  },
  //获取到今天的所在周数组
  getWeekArrByDate: function (year, month, day) {
    var dateArr;
    if (year) {
      dateArr = [year, month, day]
    } else {
      dateArr = this.gettodayinfo()
    }
    
    var dateObj = new Date(dateArr[0], dateArr[1], dateArr[2]);
    var todayYearIdx = dateObj.getFullYear();
    var todayMonthIdx = dateObj.getMonth();
    var todayDayIdx = dateObj.getDate();
    var todayWeekIdx = dateObj.getDay();
    
    
    var prevLeftDays = todayWeekIdx;
    var nextLeftDays = 7 - todayWeekIdx;
    
    var weekArr = []
    for (var i = todayDayIdx - prevLeftDays; i < todayDayIdx + nextLeftDays; i++) {
      weekArr.push(this.getDateArrByDateObj(new Date(todayYearIdx, todayMonthIdx, i)));
    }
    return weekArr;
  },
  //生成对应索引的周日期数组
  getWeekArrByIdx: function (idx) {
    var targetDateArr = this.getWeekArrByDate(this.weekBaseYear, this.weekBaseMonth, this.weekBaseDate)[0]
    var targetWeekArr = [];
    
    for (var i = targetDateArr[2] + idx * 7; i < targetDateArr[2] + (idx + 1) * 7; i++) {
      targetWeekArr.push(this.getDateArrByDateObj(new Date(targetDateArr[0], targetDateArr[1], i)))
    }
    return targetWeekArr;
  },
  
  
  //通过日期数组生成日期DOM
  getDateDomByDateArr: function (dateArr) {
    var weekDom = document.createElement("div");
    weekDom.setAttribute("class", "row");
    var weekDomStr = "";
    var todayDateArr = this.gettodayinfo();
    for (var i = 0; i < dateArr.length; i++) {
      var todayDomClassName = "";
      var isToday = false
      if (todayDateArr[0] == dateArr[i][0] && todayDateArr[1] == dateArr[i][1] && todayDateArr[2] == dateArr[i][2]) {
        todayDomClassName = "today"
        isToday = true
      }
      var currDateArr = dateArr[i];
      currDateArr[1] = currDateArr[1] + 1;
      weekDomStr += "<div datestr='" + currDateArr.join(this.sepsign) + "' class='col payload " + todayDomClassName + "'>" + (isToday ? '今' : dateArr[i][2]) + "</div>";
    }
    weekDom.innerHTML = weekDomStr;
    return weekDom;
  },
  //周历偏移
  weekCalendarOffset: function (way) {
    this.createWeekGeneral(way)
    
  },
  //月历加减
  monthoffset: function (way) {
    if (way) {
      this.showMonth++;
    } else {
      this.showMonth--;
    }
    console.log(this.showMonth);
    if (this.showMonth > 11) {
      console.log("年进一");
      this.showMonth = 0;
      this.showYear++;
    } else if (this.showMonth < 0) {
      console.log("年退一");
      this.showMonth = 11;
      this.showYear--;
    }
    
    if (this.showYear == this.gettodayinfo()[0] && this.showMonth == this.gettodayinfo()[1]) {
      this.showDay = this.gettodayinfo()[2];
    } else {
      this.showDay = false;
    }
    
    console.log("正在创建：" + this.showYear + this.sepsign + (this.showMonth + 1));
    console.log(this);
    this.create();
    
  },
  //回到今天
  tododay: function () {
    var today = new Date();
    this.showYear = this.gettodayinfo()[0];
    this.showMonth = this.gettodayinfo()[1];
    this.showDay = this.gettodayinfo()[2];
    this.create();
    console.log(calendar);
  },
  //回到当前周
  //TODO:
  toTodayWeek: function () {
    this.currWeekOffset = 0;
    this.showYear = false;
    this.showMonth = false;
    this.createWeek()
  },
  //获取月历内所有日期
  get_month_date: function () {
    //月历内所有的日期
    curr_page_arr = [];
    var datestr = "";
    for (var i = 1; i <= this.days_per_month[m]; i++) {
      datestr = y + this.sepsign + (m) + this.sepsign + i;
      curr_page_arr.push(datestr);
    }
    return curr_page_arr;
  },
  //通过日期找到dom
  get_date_dom: function (datestr) {
    //datearr:[年,月,日]
    datearr = datestr.split(this.sepsign);
    var datedom = 0;
    var calendarDom = this.calendar_dom;
    var calendarCol = calendarDom.getElementsByClassName("col");
    if (datearr[0] == this.showYear && datearr[1] == (this.showMonth + 1)) {
      for (var i = 0; i < calendarCol.length; i++) {
        if (calendarCol[i].getAttribute("date") == datearr[2]) {
          datedom = calendarCol[i];
        }
      }
    }
    return datedom;
  },
  //通过日期找到dom[新]
  getDateDOMByDateStr: function (datestr) {
    var datearr = datestr.split(this.sepsign);
    var datedom = 0;
    var calendarDom = document.getElementById("calendarMain");
    var calendarCol = calendarDom.getElementsByClassName("col");
    for (var i = 0; i < calendarCol.length; i++) {
      //console.log(calendarCol[i].getAttribute("datestr") + ":" + datestr);
      if (calendarCol[i].getAttribute("datestr") === datestr) {
        datedom = calendarCol[i];
      }
    }
    return datedom;
  },
  //在当前月历查询指定的日期
  querydate: function (data) {
    var date_dom_arr = [];
    
    //测试数据
    //					data = [
    //						"2017-11-11",
    //						"2017-11-18",
    //						"2017-11-10",
    //						"2017-11-22",
    //						"2017-11-6",
    //						"2017-11-8",
    //						"2018-1-5",
    //					];
    
    for (var i = 0; i < data.length; i++) {
      if (this.get_date_dom(data[i])) {
        date_dom_arr.push(this.get_date_dom(data[i]));
      }
    }
    return date_dom_arr;
  }
}

module.exports = calendar;



// WEBPACK FOOTER //
// ./src/common/js/calendar.js